<body>
  <div id="root">
    <app-navbar id="header"></app-navbar>
    <div id="content" class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </div>
</body>
